import { render, staticRenderFns } from "./BaseTableRefresh.vue?vue&type=template&id=1cc48958&"
import script from "./BaseTableRefresh.vue?vue&type=script&lang=js&"
export * from "./BaseTableRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports